import { render, staticRenderFns } from "./platformAccount.vue?vue&type=template&id=64644b70&scoped=true"
import script from "./platformAccount.vue?vue&type=script&lang=js"
export * from "./platformAccount.vue?vue&type=script&lang=js"
import style0 from "./platformAccount.vue?vue&type=style&index=0&id=64644b70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64644b70",
  null
  
)

export default component.exports